<template>
  <div>
    <div class="about-section">
      <div class="item-name">ABOUT ME</div>
      <p>
        Author:
        <a href="https://www.linkedin.com/in/chenxi-cheng-42a564159/">Chenxi Cheng</a>
      </p>
      <p>
        GitHub：
        <a href="https://github.com/ChenxiiCheng">ChenxiiCheng</a>
      </p>
      <div class="info">
        <p>Technology Stack：</p>
        <p>• Vue：^2.6.10</p>
        <p>• Vue-cli：^3.10.0</p>
        <p>• Vue router：^3.0.3</p>
        <p>• Element UI：^2.4.5</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about-section {
  margin-bottom: 20px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(26, 26, 26, 0.1);
  .item-name {
    font-size: 16px;
  }
  a {
    text-decoration: none;
  }
}
</style>